import { c as _c } from "react/compiler-runtime";
import CkEditorCSRRenderer from '@/components/elementary/CkEditorRenderer/CkEditorCSRRenderer';
import { TileLink } from '@/components/shared/components/Tile/variants/shared/TileLink';
import Heading from '@/components/typography/Heading';
import type { GridCardProps } from '@/types/general';
import { TileIcon } from './shared/TileIcon';
export function CompetitorsCard(t0) {
  const $ = _c(19);
  const {
    icon,
    title,
    description,
    link
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = icon && <TileIcon icon={icon} size="medium" />;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = title && <Heading tag="h3" fontSize="headingSmall" className="font-bold text-left">{title}</Heading>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="flex flex-col items-start text-left mt-2">{t2}</div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = <div className="flex flex-col">{t1}{t3}</div>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== description) {
    t5 = description && <CkEditorCSRRenderer className="mt-2 text-brand-black text-left" variant="textOnly" htmlContent={description} />;
    $[9] = description;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== link) {
    t6 = link && <TileLink className="gap-1 mt-4 md:mt-2 static opacity-100 pointer-events-auto" link={link} />;
    $[11] = link;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <div className="relative mt-3">{t5}{t6}</div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t4 || $[17] !== t7) {
    t8 = <div className="flex flex-col p-4 md:py-6 md:px-8 justify-start w-full">{t4}{t7}</div>;
    $[16] = t4;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}